import { Sparkles } from 'lucide-react';

export function AqlAssistantSuggestedCard({
  question,
  onSelect,
  disabled = false
}: {
  question: string;
  onSelect: (question: string) => void;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => onSelect(question)}
      className="aql-assistant-surface group flex min-h-[72px] w-full items-start gap-2 rounded-2xl border border-border bg-muted/35 p-3 text-left transition-all hover:border-primary/40 hover:bg-accent disabled:pointer-events-none disabled:opacity-60"
    >
      <span className="mt-0.5 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-xl border border-primary/18 bg-primary/10 text-primary">
        <Sparkles className="h-3.5 w-3.5" />
      </span>
      <span className="text-sm font-medium leading-5 text-foreground">
        {question}
      </span>
    </button>
  );
}
